<!-- Add Multiple Leads -->
<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">Add Multiple Leads</div>
    <div class="box">
      <div class="p-20 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/leads')" class="link-back">
              <i class="fas fa-arrow-circle-left mr-5"></i>Back
            </a>
          </div>
        </div>
      </div>
      <hr class="mb-0" />
      <div class="p-20 pt-0">
        <form @submit.prevent="submitBulk">
          <div class="font-bold mt-20">Applies to All Leads</div>
          <hr class="short-line left" />
          <div class="row mb-30">
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Branch</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select class="form-control border-bottom" name="branch" v-model="branch_id"
                    @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </b-form-select>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Lead Owner</div>
                </b-col>
                <b-col sm="9">
                  <template
                    v-if="checkSessionRoleId === '4' || getRoleId == '17' || getRoleId == 17 || getRoleId == '6' || getRoleId == 6">
                    <b-form-select name="lead_owner" v-validate="'required'" v-model="sharedData.owner_id"
                      class="form-control border-bottom">
                      <option value="null">Please select</option>
                      <option v-for="item in itemSales" :key="item.id" :value="item.id">{{ item.fullname }}</option>
                    </b-form-select>
                    <span class="error">{{ errors.first('lead_owner') }}</span>
                  </template>
                  <template v-else>
                    <b-form-select name="lead_owner" v-validate="'required'" disabled v-model="sharedData.owner_id"
                      class="form-control border-bottom bg-transparent">
                      <option value="null">Please select</option>
                      <option v-for="item in itemSales" :key="item.id" :value="item.id">{{ item.fullname }}</option>
                    </b-form-select>
                    <span class="error">{{ errors.first('lead_owner') }}</span>
                  </template>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Refferal Member</label>
                </b-col>
                <b-col sm="9">
                  <div class="custom-search-select">
                    <model-select autocomplete="false" :options="optionsMember"
                      @searchchange="searchMemberWithoutBranch" class="border-bottom" placeholder="Select member"
                      name="member_id" v-model="sharedData.member_id"></model-select>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Refferal PT</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select name="refferal_pt_id" v-model="sharedData.referral_pt_id"
                    class="form-control border-bottom">
                    <option value="null">Please select</option>
                    <option v-for="item in itemsPT" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Lead Source</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select name="lead_source" v-validate="'required'" v-model="sharedData.source_type_id"
                    class="form-control border-bottom">
                    <option value="null">Please select</option>
                    <option v-for="item in itemSource" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('lead_source') }}</span>
                </b-col>
              </b-row>
            </div>
          </div>

          <div class="font-bold mt-20">Leads</div>
          <hr class="short-line left" />
          <table class="table">
            <thead>
              <tr>
                <th style="width: 25%">First Name</th>
                <th style="width: 25%">Last Name</th>
                <th style="width: 15%">Country Code</th>
                <th style="width: 25%">Phone Number</th>
                <th style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in rows" :key="index">
                <td>
                  <b-form-input class="form-control border-bottom" v-model="row.first_name"
                    v-validate="'required'" :name="'first_name_' + index" type="text"></b-form-input>
                  <span class="error">{{ errors.first('first_name_' + index) }}</span>
                </td>
                <td>
                  <b-form-input class="form-control border-bottom" v-model="row.last_name"
                    v-validate="'required'" :name="'last_name_' + index" type="text"></b-form-input>
                  <span class="error">{{ errors.first('last_name_' + index) }}</span>
                </td>
                <td>
                  <model-select autocomplete="false" :options="optionCountryCode" @searchchange="onCountryCode"
                    class="border-bottom" placeholder="country code" :name="'country_code_' + index"
                    v-model="row.phone_country_code"></model-select>
                </td>
                <td>
                  <b-form-input class="form-control border-bottom" v-model="row.phone_number"
                    v-validate="'required|regex:^[1-9][0-9]*$'" :name="'phone_number_' + index" type="text"
                    @blur="normalizePhoneNumber(index)"></b-form-input>
                  <span class="error">{{ errors.first('phone_number_' + index) }}</span>
                </td>
                <td>
                  <a v-if="rows.length > 1" @click="removeRow(index)" class="color-red">
                    <i class="fas fa-times"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <a @click="addRow" class="btn-grey"><i class="fas fa-plus-square mr-5"></i>Add Row</a>

          <div class="text-right mt-15">
            <button type="submit" class="btn-primary">Submit</button>
          </div>
        </form>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import { Auth } from "@/api";

import { ModelSelect } from "vue-search-select";
import Mixin from '../../mixins/memberMixin'

export default {
  name: "addMultipleLeads",
  components: {
    ModelSelect
  },
  mixins: [Mixin],
  data: function () {
    return {
      loadingActive: false,
      itemSales: [],
      itemSource: [],
      dataBranch: [],
      itemsPT: [],
      optionsMember: [{ value: null, text: 'Please select' }],
      optionCountryCode: [],
      branch_id: null,
      checkSessionRoleId: "",
      getRoleId: Auth.Session.get().paradigm_role,
      sharedData: {
        owner_id: null,
        source_type_id: null,
        referral_pt_id: null,
        member_id: null
      },
      rows: [
        { first_name: "", last_name: "", phone_number: "", phone_country_code: "+62" }
      ]
    };
  },
  methods: {
    onCountryCode(event) {
      console.log("event", event);
    },
    changeBranch(event) {
      this.fetchData()
    },
    addRow() {
      this.rows.push({ first_name: "", last_name: "", phone_number: "", phone_country_code: "+62" })
    },
    removeRow(index) {
      this.rows.splice(index, 1)
    },
    normalizePhoneNumber(index) {
      // Country code +62 sudah dipilih terpisah di dropdown, jadi field ini harus
      // nomor nasional TANPA 0 di depan (bukan "0812...", tapi "812...").
      const raw = this.rows[index].phone_number
      if (!raw) return
      let cleaned = `${raw}`.replace(/[^0-9+]/g, '')
      if (cleaned.startsWith('+62')) {
        cleaned = cleaned.slice(3)
      } else if (cleaned.startsWith('62') && cleaned.length > 9) {
        cleaned = cleaned.slice(2)
      }
      cleaned = cleaned.replace(/\+/g, '')
      cleaned = cleaned.replace(/^0+/, '')
      if (cleaned !== raw) {
        this.rows[index].phone_number = cleaned
      }
    },
    submitBulk() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.loadingActive = true
          axios.defaults.headers.common["X-Access-Token"] = Auth.Session.get().paradigm_token;
          axios.post("crm/v1/leads/bulk", {
            owner_id: this.sharedData.owner_id,
            source_type_id: this.sharedData.source_type_id,
            referral_pt_id: this.sharedData.referral_pt_id,
            member_id: this.sharedData.member_id,
            leads: this.rows
          }).then(response => {
            this.loadingActive = false
            const results = response.data.data.results
            const failed = results.filter(r => !r.success)
            const succeeded = results.filter(r => r.success)

            if (failed.length === 0) {
              this.$swal('Successfully!', `${succeeded.length} leads berhasil ditambahkan!`, 'success')
              this.$router.push('/leads')
            } else {
              // sisakan baris yang gagal saja supaya user bisa perbaiki & submit ulang
              this.rows = failed.map(f => ({
                first_name: f.first_name,
                last_name: f.last_name,
                phone_number: f.phone_number
              }))
              const messages = failed.map(f => `${f.first_name || '-'} ${f.last_name || ''}: ${f.error}`).join('<br/>')
              this.$swal({
                title: `${succeeded.length} berhasil, ${failed.length} gagal`,
                html: messages,
                type: 'warning'
              })
            }
          }).catch(error => {
            this.loadingActive = false
            console.log("error", error.response);
            if (error.response && error.response.data) {
              this.$toast.success(error.response.data.error, "Error", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
            } else {
              this.$toast.success("Cant saved data!", "Error", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
            }
          });
        } else {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff"
          });
        }
      });
    },
    openPage(event) {
      this.$router.push(event);
    },
    fetchData() {
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      if (Auth.Session.get().paradigm_role === "1") {
        axios
          .get("crm/v1/sales")
          .then(response => {
            this.itemSales = response.data.data.rows;
          })
          .catch(error => {
            console.log("error", error);
          });
      } else {
        axios
          .get(
            "crm/v1/sales/my_sales/" +
            Auth.Session.get().paradigm_id +
            "?status=active&sorting=fullname&sorting_type=asc&branch_id=" +
            this.branch_id
          )
          .then(response => {
            this.itemSales = response.data.rows;
          })
          .catch(error => {
            console.log("error", error);
          });
      }
      axios
        .get("crm/v1/leads_source_type?status=active")
        .then(response => {
          this.itemSource = response.data.data.rows;
        })
        .catch(error => {
          console.log("error", error);
        });

      axios
        .get("crm/v1/country_code")
        .then(response => {
          this.optionCountryCode = [];
          for (let i = 0; i < response.data.data.length; i++) {
            const el = response.data.data[i];
            this.optionCountryCode.push({
              value: el.dial_codes,
              text: el.dial_codes + "  " + el.emoji + " " + el.name
            });
          }
        })
        .catch(error => {
          console.log("error", error);
        });

      axios
        .get(
          "fitness/v1/personal_training?status=active&sorting=name&sorting_type=asc&branch_id=" + this.branch_id)
        .then((response) => {
          this.itemsPT = response.data.data.rows;
        })
    }
  },
  created() {
    this.checkSessionRoleId = Auth.Session.get().paradigm_role;
    if (Auth.Session.get().paradigm_role === "4") {
      this.sharedData.owner_id = null;
    } else {
      this.sharedData.owner_id = Auth.Session.get().paradigm_id;
    }

    this.branch_id = Auth.Session.get().paradigm_branch_id
    this.fetchData();
  }
};
</script>

<style></style>
